export enum EFeedbackApplicationType {
  WEB_APPLICATION = "WEB_APPLICATION",
  MOBILE_APPLICATION = "MOBILE_APPLICATION",
}
